import { FormGroupState } from "ngrx-forms";

export interface ITermsConditionsState {
    form: FormGroupState<TermsConditionsModel>;
}

export class TermsConditionsModel {
    readAllInformationAgreement: boolean = false;
}